module.exports = __webpack_public_path__ + "static/robot-86239a0b1da62a0945638b15d721f1f0.svg";